export const replaceDash = (text) => text.replace(/-/g, ' ')

// Humanises an internal identifier for display: splits camelCase/PascalCase, turns dashes and
// underscores into spaces, and title-cases each word — while preserving all-caps acronyms
// (API, SSO, AI, LC, DR, VCE…). e.g. "JournalCategories" → "Journal Categories",
// "Analytics-Chart" → "Analytics Chart", "classes-maintenance" → "Classes Maintenance",
// "AI-Analyst" → "AI Analyst".
export const humanize = (text = '') =>
  String(text || '')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2') // camelCase / PascalCase boundary
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2') // ACRONYMWord → ACRONYM Word
    .replace(/[-_]+/g, ' ') // dashes & underscores → space
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => (w === w.toUpperCase() ? w : w.charAt(0).toUpperCase() + w.slice(1)))
    .join(' ')
